import React from "react";

export default function Header() {
  return (
    <div className="bg-yellow-400 text-center py-4">
      <p className="text-4xl font-extrabold italic ">SplitIt</p>
    </div>
  );
}
